<template>
  <v-container
    fluid
    class="pa-0 ma-0 d-flex flex-column justify-space-between"
    style="height: 85vh; border-radius: 4px; background: #FFF; !important;"
    elevation-3
  >
    <NewCi :new_dialog="new_dialog" :closeEditor="closeEditor" :editor_open="editor_open" />
    <v-container fluid class="px-0 pt-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Enviados</v-toolbar-title>
      </v-toolbar>
      <v-container class="pa-4 ma-0">
        <v-btn color="green lighten-1" class="white--text" @click="editor_open = true">
          <v-icon class="mr-2">mdi-plus</v-icon>
          Criar</v-btn
        >
      </v-container>
      <CiList :internal_communications="sended_ics" :sended="true" />
    </v-container>
  </v-container>
</template>

<script>
import CiList from '../components/CiList'
import NewCi from '../components/NewCi'
import { mapState } from 'vuex'

export default {
  name: 'Ci',
  components: { CiList, NewCi },
  data: function () {
    return {
      new_dialog: false,
      editor_open: false,
    }
  },
  computed: {
    ...mapState('ci', ['sended_ics']),
  },
  methods: {
    closeEditor() {
      this.editor_open = false
    },
  },
}
</script>
